import React from 'react'
import orderCategoryFragment from '@data/fragments/categories/orderCategory'
import orderBy from 'lodash/orderBy'

import {orderCategory} from './__generated__/orderCategory'
import Product from './Product'

import styles from './styles.module.css'

export interface CategoryProps {
  menuId: string
  category: orderCategory
  hidePrice: boolean
  layout: string
  productsLayout: string
  productCardDesign: string
  sorting: any
  hideNotAvailableProducts: boolean
}

export default class Category extends React.Component<CategoryProps> {
  static fragment = orderCategoryFragment

  getProducts() {
    let productList = this.props.category.products.filter(product => {
      if (this.props.hideNotAvailableProducts && product.isOutOfStock) {
        return false
      }
      if (!product.availabilityAt) return false
      if (product.availabilityAt.notAvailableMessage) return true

      return !!product.availabilityAt.available
    })

    if (this.props.sorting) {
      if (this.props.sorting.type === 'price') {
        productList = orderBy(productList, product => product.availabilityAt.finalPrice, [
          this.props.sorting.order
        ])
      }

      if (this.props.sorting.type === 'name') {
        productList = orderBy(productList, ['name'], [this.props.sorting.order])
      }
    }

    return productList
  }

  renderProducts() {
    let className =
      this.props.productsLayout === 'compact'
        ? {
            mobile: 'col-xs-6',
            v1: 'col-xs-6 col-md-3',
            v2: 'col-xs-3 col-md-2'
          }[this.props.layout]
        : {
            mobile: 'col-xs-12',
            v1: 'col-xs-12 col-md-6',
            v2: 'col-xs-6 col-md-4'
          }[this.props.layout]
    className += ' menuProductCol'
    return this.getProducts().map(product => {
      return (
        <div key={product._id} className={className}>
          <Product
            productsLayout={this.props.productsLayout}
            productCardDesign={this.props.productCardDesign}
            hidePrice={this.props.hidePrice}
            // @ts-expect-error ts-migrate(2739) FIXME: Type 'orderCategory_products' is missing the follo... Remove this comment to see the full error message
            product={product}
            menuId={this.props.menuId}
          />
        </div>
      )
    })
  }

  render() {
    const {category} = this.props

    if (this.getProducts().length === 0) return null
    return (
      <>
        {/* The id of the div bellow is intended as a unique match to Tiramisu's
      layout. Please do not change it. */}
        <div className={styles.container} id={`t111_${category._id}`}>
          <div className={styles.name}>{category.name}</div>
          <div className={styles.products}>
            <div className="row">{this.renderProducts()}</div>
          </div>
        </div>
      </>
    )
  }
}
